/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ClassifierType {
    VALUATION = 'VALUATION',
    DOCUMENT = 'DOCUMENT',
    VALUATION_INPUT = 'VALUATION_INPUT',
    VALUATION_PERSON_INPUT_SOURCE = 'VALUATION_PERSON_INPUT_SOURCE',
    VALUATION_PERSON_INPUT_USE = 'VALUATION_PERSON_INPUT_USE',
    INVESTOR_COHORT = 'INVESTOR_COHORT',
}
